import {MODAL_ACTIONS} from 'food-benefit.module/common/domain/constants';

class ModalRejectRequestController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.cancel = MODAL_ACTIONS.CANCEL;
    this.reject = MODAL_ACTIONS.REJECT;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  dismiss() {
    $('.modal').modal('hide');
  }

  actionButton(action) {
    this.setAction(this.EventEmitter({status: action, request: this.request}));
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.REJECT'
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

}

export default ModalRejectRequestController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalRejectRequest/modalRejectRequest.controller.js